"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useOnKeyboardConfirm;
var _react = require("react");
var _contains = _interopRequireDefault(require("lodash/fp/contains"));
var CONFIRM_KEYS = [13, 32];
function useOnKeyboardConfirm(callback, dependencyList) {
  return (0, _react.useCallback)(function (e) {
    if ((0, _contains["default"])(e.keyCode)(CONFIRM_KEYS)) {
      callback === null || callback === void 0 ? void 0 : callback(e);
      e.preventDefault();
    }
  }, dependencyList); // eslint-disable-line react-hooks/exhaustive-deps
}